import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={33}
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M28 5.83496V16.5016" stroke={props.stroke} strokeWidth={2.66667} />
    <path d="M4 16.501V27.1676" stroke={props.stroke} strokeWidth={2.66667} />
    <path
      d="M28 16.501C28 9.87358 22.6274 4.50098 16 4.50098C12.6097 4.50098 9.54773 5.90695 7.3654 8.16764M4 16.501C4 23.1284 9.3726 28.501 16 28.501C19.2371 28.501 22.1748 27.2192 24.3333 25.1356"
      stroke={props.stroke}
      strokeWidth={2.66667}
    />
  </svg>
);

export default SVGComponent;
